import React, { FC, PropsWithChildren } from 'react';
// eslint-disable-next-line no-restricted-imports
import baseStyled, { ThemeProvider, StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { useConfig } from 'providers/useConfig/ConfigContext';
import { LayoutConfig } from 'types/Config';
import { LAYOUT_CONFIG_DEFAULT } from 'providers/useConfig/DefaultConfigs';
import { GlobalStyle } from 'style/styled-components/cssGlobalStyles';

export const styled = baseStyled;

export const ThemeConfigConnector: FC<PropsWithChildren> = ({ children }) => {
    const { config } = useConfig();

    const theme: { globalConfig: LayoutConfig; brandedConfig: LayoutConfig } = {
        globalConfig: config?.layout_config ?? LAYOUT_CONFIG_DEFAULT,
        brandedConfig: {
            ...(config?.layout_config ?? LAYOUT_CONFIG_DEFAULT),
        },
    };

    return (
        <StyleSheetManager
            shouldForwardProp={(propName, target) => {
                if (typeof target === 'string') {
                    return isPropValid(propName);
                }
                return true;
            }}
            enableVendorPrefixes
        >
            <ThemeProvider theme={theme}>
                <GlobalStyle theme={theme} />
                {children}
            </ThemeProvider>
        </StyleSheetManager>
    );
};
